<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select size="small" v-model="formDatas.syncStatus" clearable @change="partserch"
                        placeholder="每刻同步" style="width: 130px">
                        <el-option label="是" :value="2" key="2"></el-option>
                        <el-option label="否" :value="1" key="1"></el-option>
                    </el-select>
                    <el-select size="small" v-model="formDatas.syncStatusZaitu" clearable @change="partserch"
                        placeholder="在途同步" style="width: 130px">
                        <el-option label="是" :value="2" key="2"></el-option>
                        <el-option label="否" :value="1" key="1"></el-option>
                    </el-select>
                    <el-select size="small" v-model="formDatas.syncStatusZaituDtCharge" clearable @change="partserch"
                        placeholder="在途部门负责人" style="width: 130px">
                        <el-option label="是" :value="2" key="2"></el-option>
                        <el-option label="否" :value="1" key="1"></el-option>
                    </el-select>
                    <el-select size="small" v-model="formDatas.syncStatusJindie" clearable @change="partserch"
                        placeholder="金蝶" style="width: 130px">
                        <el-option label="是" :value="2" key="2"></el-option>
                        <el-option label="否" :value="1" key="1"></el-option>
                    </el-select>
                     <el-select size="small" v-model="formDatas.syncStatusDidi" clearable @change="partserch"
                        placeholder="滴滴" style="width: 130px">
                        <el-option label="是" :value="2" key="2"></el-option>
                        <el-option label="否" :value="1" key="1"></el-option>
                        <el-option label="失败" :value="3" key="3"></el-option>
                        <el-option label="不需要" :value="4" key="4"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="warning" size="small" style="margin-right: 10px;"
                        @click="FXXKdepartment">全量同步纷享销客部门</el-button>
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="fmdId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" :expand-option="expandOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑部门' : '新增部门'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="对应每刻部门id" prop="dtMeikeId">
                                <el-input v-model="form.dtMeikeId" type="textarea" :row="2" style="width: 50%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="对应每刻上级id" prop="dtMeikeParentId">
                                <el-input v-model="form.dtMeikeParentId" type="textarea" :row="2" style="width: 50%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>

import { getFxxkMeikeDepartmentListTree, addAjPurchasePublicItem, updateFxxkMeikeDepartment, deleteAjPurchasePublicItem, updateSyncFxxkMeikeDepartmentAll } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            expandOption: {
                expandable: ({ row, column, rowIndex }) => {
                    if (!row.child || row.child.length == 0) {
                        return false;
                    }
                },
                render: ({ row, column, rowIndex }, h) => {
                    console.log(this.$refs.vetable)
                    return (
                        <div >{
                            row.child.map((item, index) => {
                                const str = <div style="width:100%;display:flex;padding-left:120px;overflow-x:auto;">
                                    <div style="min-width:120px;text-align:center;padding:10px;">
                                        {item.name}
                                    </div>
                                    <div style="min-width:300px;text-align:center;padding:10px;">
                                        {item.fmdManagerId}
                                    </div>
                                    <div style="min-width:120px;text-align:center;padding:10px;">
                                        {item.fmdManagerIdName}
                                    </div>
                                    <div style="min-width:180px;text-align:center;padding:10px;">
                                        {item.createtime}
                                    </div>
                                    <div style="min-width:90px;text-align:center;padding:10px;">
                                        {item.syncStatus}
                                    </div>
                                    <div style="min-width:90px;text-align:center;padding:10px;">
                                        {item.syncStatusZaitu}
                                    </div>
                                    <div style="min-width:120px;text-align:center;padding:10px;">
                                        {item.syncStatusZaituDtCharge}
                                    </div>
                                    <div style="min-width:120px;text-align:center;padding:10px;">
                                        {item.syncStatusJindie}
                                    </div>
                                    <div style="min-width:200px;text-align:center;padding:10px;">
                                        {item.dtJindieId}
                                    </div>
                                    <div style="min-width:200px;text-align:center;padding:10px;">
                                        {item.dtMeikeId}
                                    </div>
                                    <div style="min-width:200px;text-align:center;padding:10px;">
                                        {item.dtMeikeParentId}
                                    </div>
                                     <div style="min-width:120px;text-align:center;padding:10px;">
                                        {item.syncStatusDidi}
                                    </div>
                                     <div style="min-width:200px;text-align:center;padding:10px;">
                                        {item.dtDidiId}
                                    </div>
                                    <div style="min-width:160px;text-align:center;padding:10px;">
                                        <el-button
                                            size="mini"
                                            type="text"
                                            on-click={() => this.handleEdit(item)}
                                        >
                                            编辑
                                        </el-button>
                                    </div>

                                </div>
                                return str
                            })
                        }


                        </div>

                    );
                },
            },
            key: 'fmdId',
            dialog: false,
            edit: false,
            form: {
                appiName: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "expand",

                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },

                {
                    field: "name",
                    key: "name",
                    title: "部门名称",
                    align: "center",
                    width: 120,
                    edit: true,
                },
                {
                    field: "fmdManagerId",
                    key: "fmdManagerId",
                    title: "部门经理",
                    width: 120,
                    align: "center",
                    edit: true,
                },
                {
                    field: "fmdManagerIdName",
                    key: "fmdManagerIdName",
                    title: "部门经理",
                    align: "center",
                    width: 100,
                    edit: true,
                },

                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "syncStatus",
                    key: "syncStatus",
                    title: "每刻",
                    width: 60,
                    fixed: 'right',
                    align: "center",
                },
                {
                    field: "syncStatusZaitu",
                    key: "syncStatusZaitu",
                    title: "在途",
                    width: 60,
                    fixed: 'right',
                    align: "center",
                },
                {
                    field: "syncStatusZaituDtCharge",
                    key: "syncStatusZaituDtCharge",
                    title: "在途部门长",
                    width: 90,
                    fixed: 'right',
                    align: "center",
                },
                {
                    field: "syncStatusJindie",
                    key: "syncStatusJindie",
                    title: "金蝶",
                    width: 60,
                    fixed: 'right',
                    align: "center",
                },
                {
                    field: "dtJindieId",
                    key: "dtJindieId",
                    title: "金蝶部门id",
                    width: 120,
                    fixed: 'right',
                    align: "center",
                },
                {
                    field: "dtMeikeId",
                    key: "dtMeikeId",
                    title: "每刻部门id",
                    width: 90,
                    fixed: 'right',
                    align: "center",
                },
                {
                    field: "dtMeikeParentId",
                    key: "dtMeikeParentId",
                    title: "每刻上级id",
                    width: 90,
                    fixed: 'right',
                    align: "center",
                },
                 {
                    field: "syncStatusDidi",
                    key: "syncStatusDidi",
                    title: "滴滴",
                    width: 60,
                    fixed: 'right',
                    align: "center",
                },
                    {
                    field: "dtDidiId",
                    key: "dtDidiId",
                    title: "滴滴部门id",
                    width: 120,
                    fixed: 'right',
                    align: "center",
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                syncStatus: "",
                syncStatusZaitu: "",
                syncStatusZaituDtCharge:"",
                syncStatusJindie:"",
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
        },
        FXXKdepartment() {
            this.openLoading()
            updateSyncFxxkMeikeDepartmentAll().then(res => {
                this.loadings.close()
                if (res) {
                    this.$message({
                        type: "success",
                        message: "获取成功!",
                    });
                }
            })
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjPurchasePublicItem({ fmdIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjPurchasePublicItem({ fmdIds: row.fmdId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjPurchasePublicItem(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateFxxkMeikeDepartment(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.fmdId = row.fmdId
                    console.log(jsonObj);
                    updateFxxkMeikeDepartment(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getFxxkMeikeDepartmentListTree(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getFxxkMeikeDepartmentListTree(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getFxxkMeikeDepartmentListTree(this.formDatas).then((res) => {
                this.tableData = res.data;
                // this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>